module.exports = __webpack_public_path__ + "static/media/C9.b73ba99.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C9.mp4
// module id = NAbZ
// module chunks = 8